import { useRouter, useSearchParams } from 'next/navigation';
import { getNextApiUrl, requestNextApi } from '@/utils/next-api';
import Toast from '@/components/Toast';
import { useUnleash } from '@/unleash';
import { getUTMStringFromLocalStorage } from '@/containers/AnalyticsContainer/UTMContainer/UTMContainer.utils';
import { TLoginParams } from '../types';

export const useLogin = () => {
  const { data: regLimitations } = useUnleash('web.reg.limitation');
  const isUtmLoginActive = regLimitations?.isUtmLoginActive;
  const searchParams = useSearchParams();

  const router = useRouter();

  const handleLogin = async (loginParams: TLoginParams) => {
    try {
      const response = await requestNextApi('auth/login-callback-new', {
        method: 'POST',
        data: loginParams,
      });
      window.location.href = response?.redirectUrl || '/';
    } catch (error: any) {
      Toast.open({
        variant: 'error',
        children: error?.message,
      });
    }
  };

  const handleUtmLogin = async () => {
    const backUrl = searchParams?.get('backUrl');
    if (isUtmLoginActive) {
      const utmParams = getUTMStringFromLocalStorage()?.slice(0, 100);

      const response = await requestNextApi('auth/login', {
        method: 'POST',
        data: {
          utmParams,
          backUrl,
        },
      });
      window.location.href = response?.loginUrl;
    } else {
      router.push(getNextApiUrl(`auth/login?backUrl=${backUrl}`));
    }
  };

  return {
    handleLogin,
    handleUtmLogin,
  };
};
